import { GetAddProfileIngressModalQuery } from './components/Header/LoggedInHeader/MyAccount/Dropdown/HouseholdMembers/AddProfileModal/getAddProfileModal';

export const addProfileModalMock: GetAddProfileIngressModalQuery = {
  client: {
    addProfileIngressModal: {
      media: {
        baseUrl: 'https://res.cloudinary.com/stitch-fix/image/upload/',
        mediaPath: 'v1752012940/onboarding/add-profile-modal-image.jpg',
        altText: 'Male and female models wearing Stitch Fix clothing',
        height: 4088,
        width: 2016,
      },
      title: {
        formatted: 'Now you can *shop for your family*',
        plain: 'Now you can shop for your family',
      },
      buttonCta: {
        actionType: 'ADD_A_PROFILE',
        label: {
          key: 'add_a_profile',
          text: 'Add a profile',
        },
        url: 'https://www.stitchfix.com/add-profile',
      },
      body: [
        'Create profiles for the adults and kids in your life',
        'Get Fixes or shop Freestyle for each person',
        'Switch between profiles without logging out',
      ],
    },
  },
};
